import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'

import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import download from 'downloadjs';
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import csvHelper from '../reports/importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import JSZip from "jszip";

import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import Multiselect from 'vue-multiselect'
Vue.component("downloadExcel", JsonExcel);

export default {
	name: 'crossdockvisibility',
	components: {
		Paginate,
		Pagination,
		JsonExcel,
		DatePicker,
		Loader,
		BasicSelect,
		Multiselect
	},
	data() {
		return {
			isLoadingforxls: false,
			csvFieldsForXls: {},
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			fromDateFlt: '',
			toDateFlt: '',
			isLoading: false,
			listClientData: [],
			listWarehouseData: [],
            channellist:[],
			ClientErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',
			searchchannel: '',
			formattedDate: '',
			user_type: '',
			userid: '',
			show: false,
			download: true,
			dataFilter2: '',
			dataFilter: '',
			reportname: '',
			recordLimit: 0,
			limitExeed: false,
			currentDate: '',
			OrderId: '',
			productid:'',
			useremail:'',
			crossDockData: [],
			orderStatus: '',
			listcrossDockDataCSV: [],
			listReportDataforxls:[]
		}
	},
	computed: {},
	filters: {

		moment: function (date) {
			if (date != null)
				return moment(date).format('DD-MM-YYYY');
		},
		momentDateTime: function (date) {
			if (date != null)
				return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail=userdetail.email;
		this.userid = userdetail.userid;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname = this.$t('userProperties.crossDockMaterialVisibilityReport')
		this.reportname = this.reportname+ moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.pageNo = 0;
		this.user_type = userdetail.utype;
		this.orderStatus = 'allocated'
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getSalesChannels()
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectWarehouse = true;
				// this.getWarehouseList();
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'))
				break
		}
		if (localStorage.getItem("selectedWarehouse")!=='undefined' && localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getRecordLimit();
		this.calldateFunction();
		}
	},
	methods: {
		calldateFunction() {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');

			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.toDateFlt = this.currentDate;
			this.fromDateFlt = dt;

		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype1() {
			this.show = true;
			this.download = false;
            this.getCrossDockForXLS(3);
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},

		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},

		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getClientList() {
		// 	this.pageNo = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageNo = 0;

		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageNo = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		if (this.clientid)
        //         this.getSalesChannels();
		// 			if (this.user_type != 'warehouse_user') {
		// 				this.listWarehouseData = [];
		// 				this.getWarehouseList();
		// 				if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 					this.warehouse = this.warehouseid = '';
		// 				} else {
		// 					this.warehouse = '';
		// 				}
		// 			}
		// 	}

		// 	this.pageNo = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageNo = this.totalPage = 0;
		// 	if (this.user_type == 'client_user') {
		// 		//this.getMerchantList();
		// 	}
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
        //             this.getSalesChannels();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
        getSalesChannels() {
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');

            if (this.clientid == '') {
              this.ClientErr = this.$t('srReport.clientError');
              return false;
            }
            axios({
              method: 'POST',
              'url': apiUrl.api_url + 'orderSalesChannelList',
              'data': {
                clientid: localStorage.getItem("selectedClient")
              },
              headers: {
                'Authorization': 'Bearer ' + myStr,
              }
            })
              .then(result => {
                this.channellist = result.data.data;
              }, error => {
                console.error(error);
              });
          },
		getCrossDockAllocatedData(){
             this.currentPage=1;
			 this.crossDockReportData(2);
		 },
		crossDockReportData(csvCheck=0){
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var fromDate = '';
			var toDate = '';
			var dataFilter = {};
            if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			if (localStorage.getItem("selectedClient") == 'undefined') {
				this.ClientErr = this.$t('common.clientError');
				this.$alertify.error(this.$t('common.clientError'));
				this.pageNo = this.totalPage = 0;
				this.crossDockData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.$alertify.error(this.$t('common.warehouseError'));
				this.pageNo = this.totalPage = 0;
				this.crossDockData = [];
				return false;
			}
            if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromDate = this.dateFormat(this.fromDateFlt) + " 00:00:00";
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				toDate = this.dateFormat(this.toDateFlt) + " 23:59:59";
			}
			this.isLoading = true;
			let params= {
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: localStorage.getItem("selectedWarehouse"),
				eancode: this.productid?this.productid:null,
				orderid: this.OrderId?this.OrderId:null,
				saleschannel: this.searchchannel?this.searchchannel:null,
				fromdate: fromDate,
				todate: toDate,
				reporttype: this.orderStatus

			}
			if(csvCheck !==1){
				params.offset = (this.currentPage - 1) * this.pageLimit;
				params.limit = this.pageLimit;
			}
			Object.entries(params).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
            axios({
				method: 'GET',
				url: `${apiUrl.api_url}crossdockorders`,
				params: params,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
			.then(response=>{
                    if(csvCheck==1){
                         if(response.data.count){
                            this.show = true;
							this.download = false;
							this.listcrossDockDataCSV = [];
							var skipFilter = [];

							if(this.orderStatus=='allocated'){
								this.csvFields = {
									'saleschannel': this.$t('common.salesChannel'),
									'orderid':this.$t('common.orderID'),
									'itemid': this.$t('orders.orderItemId'),
									'createddate': this.$t('packingb2b.b2bPacking.table.columns.orderCreatedDate'),
									'eancode': this.$t('common.eanCode'),
									'orderqty': this.$t('packingb2b.b2bPacking.table.columns.orderQty'),
									'drid': this.$t('userProperties.allocatedDRId'),
									'allocatedqty': this.$t('stockTransfer.allocatedQty'),
									'allocateddate': this.$t('userProperties.allocationDateTime')

								}
							}
							if(this.orderStatus=='packed'){
								this.csvFields = {
									'saleschannel':this.$t('common.salesChannel'),
									'orderid':this.$t('common.orderID'),
									'itemid':this.$t('orders.orderItemId'),
									'createddate':this.$t('packingb2b.b2bPacking.table.columns.orderCreatedDate'),
									'eancode':this.$t('common.eanCode'),
									'orderqty':this.$t('packingb2b.b2bPacking.table.columns.orderQty'),
									'drid':this.$t('userProperties.allocatedDRId'),
									'allocatedqty': this.$t('stockTransfer.allocatedQty'),
									'allocateddate':this.$t('userProperties.allocationDateTime'),
									//'': this.$t('userProperties.packingDateTime')
								}
							}
						     skipFilter = ['rowcount','grndate','warehouseid'];
							var dateFilter = ['createddate','allocateddate'];

							this.listcrossDockDataCSV = response.data.data;
							csvHelper.data.jsonToCSV(this.$t('userProperties.crossDockMaterialVisibilityReport'), this.listcrossDockDataCSV, this.csvFields, dateFilter, skipFilter, dataFilter);
						 }
					}
					else if(response.data.status==false){
						this.totalRows = 0;
						this.crossDockData = [];
						this.$alertify.error(response.data.msg);
					}
					else{

						this.crossDockData = response.data.data;
						this.totalRows = response.data.count;
						if(this.totalRows< this.pageLimit){
							this.totalPage=1;
						}
						else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}

					}
					this.isLoading = false;
			})
			.catch(err=>{
				console.error(err)
				this.isLoading = false;
			})

		},
		getCrossDockForXLS(csvCheck=0){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fromDate = '';
			var toDate = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromDate = this.dateFormat(this.fromDateFlt) + " 00:00:00";
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				toDate = this.dateFormat(this.toDateFlt) + " 23:59:59";
			}
			let params= {
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: localStorage.getItem("selectedWarehouse"),
				eancode: this.productid?this.productid:null,
				orderid: this.OrderId?this.OrderId:null,
				saleschannel: this.searchchannel?this.searchchannel:null,
				fromdate: fromDate,
				todate: toDate,
				reporttype: this.orderStatus
			}
			Object.entries(params).forEach(([k, v]) => {
				let skipkeys = [];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);
				}
			});
			axios({
				method: 'GET',
				url: `${apiUrl.api_url}crossdockorders`,
				params: params,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
			.then(response => {
				    if(csvCheck==3){
					if (response.data.count > 0) {

						this.listReportDataforxls = [];
						if(this.orderStatus=='allocated'){
						this.csvFieldsForXls[this.$t('common.salesChannel')] = 'saleschannel',
						this.csvFieldsForXls[this.$t('common.orderID')] = 'orderid',
						this.csvFieldsForXls[this.$t('orders.orderItemId')] = 'itemid',
						this.csvFieldsForXls[this.$t('packingb2b.b2bPacking.table.columns.orderCreatedDate')] = 'createddate',
						this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode',
						this.csvFieldsForXls[this.$t('packingb2b.b2bPacking.table.columns.orderQty')] = 'orderqty',
						this.csvFieldsForXls[this.$t('userProperties.allocatedDRId')] = 'drid',
						this.csvFieldsForXls[this.$t('stockTransfer.allocatedQty')] = 'allocatedqty',
						this.csvFieldsForXls[this.$t('userProperties.allocationDateTime')] = 'allocateddate'
						}
						if(this.orderStatus=='packed'){
						this.csvFieldsForXls[this.$t('common.salesChannel')] = 'saleschannel',
						this.csvFieldsForXls[this.$t('common.orderID')] = 'orderid',
						this.csvFieldsForXls[this.$t('orders.orderItemId')] = 'itemid',
						this.csvFieldsForXls[this.$t('packingb2b.b2bPacking.table.columns.orderCreatedDate')] = 'createddate',
						this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode',
						this.csvFieldsForXls[this.$t('packingb2b.b2bPacking.table.columns.orderQty')] = 'orderqty',
						this.csvFieldsForXls[this.$t('userProperties.allocatedDRId')] = 'drid',
						this.csvFieldsForXls[this.$t('stockTransfer.allocatedQty')] = 'allocatedqty',
						this.csvFieldsForXls[this.$t('userProperties.allocationDateTime')] = 'allocateddate'
						//this.csvFieldsForXls[this.$t('userProperties.packingDateTime')] = ''
						}

						this.listReportDataforxls = response.data.data;
						this.listReportDataforxls.forEach(entry =>{
                             if(entry.createddate != '' && entry.createddate !=null){
								entry.createddate = moment(entry.createddate).format('DD/MM/YYYY HH:mm:ss');
							 }
							 if(entry.allocateddate != '' && entry.allocateddate !=null){
								entry.allocateddate = moment(entry.allocateddate).format('DD/MM/YYYY HH:mm:ss');
							 }
							 if(entry.packingdate != '' && entry.packingdate !=null){
								entry.packingdate = moment(entry.packingdate).format('DD/MM/YYYY HH:mm:ss');
							 }
						})
					}
				}
			}, error => {
				console.error(error);
			})
		},
        onPageChange(page){
            this.currentPage=page;
			this.crossDockReportData();
        },
        loadDockReport(status){
            this.totalRows=0
            this.searchchannel='';
			this.OrderId = '';
			document.getElementById("OrderId").value = "";
            this.productid = '';
			document.getElementById("productid").value = "";
			this.crossDockData=[]
			this.calldateFunction();
			this.ClientErr = "";
			this.WarehouseErr = "";
			this.orderStatus = status;

			if (this.user_type == 'warehouse_user') {
                this.client = '';
				this.clientid = '';
			} else if (this.user_type == 'client_user') {
                this.warehouse = '';
				this.warehouseid = '';
			} else {
                this.client = '';
				this.clientid = '';
				this.warehouse = '';
				this.warehouseid = '';
			}
		},
		resetSearch(){
			this.fromDateFlt= '';
			this.toDateFlt= '';
			this.totalRows=0
            this.searchchannel=''
			this.OrderId=''
            this.productid=''
			this.crossDockData=[]
			this.ClientErr = "";
			this.WarehouseErr = "";
			this.calldateFunction();

			if (this.user_type == 'warehouse_user') {
                this.client = '';
				this.clientid = '';
			} else if (this.user_type == 'client_user') {
                this.warehouse = '';
				this.warehouseid = '';
			} else {
                this.client = '';
				this.clientid = '';
				this.warehouse = '';
				this.warehouseid = '';
			}
		}
	} // end methods

}



// WEBPACK FOOTER //
// ./src/views/components/crossDockMaterialVisibility/crossDockMaterialVisibility.component.js